//GeneratorFlag:[NoChange]
import Position from './position';

export default {Position}
export{Position}